import { throttle } from '../util/timing';
import { isObject } from '../util/typeGuards';

import { ThrottleSettings } from './types';

export type ThrottleFuncSetup = {
  call: () => void,
  cancel: () => void,
  setData: (data: any) => void,
  getData: () => any,
}
let throttleFunctionData: Record<string, any> = {};
/**
 * Creates a throttle function setup to use for throttling symbol data updates
 */
export function throttleFunctionSetupForSymbolDataUpdates(
  name: string,
  initialData: any,
  throttleDelayInMS: number,
  throttleOptions: ThrottleSettings,
  functionToCall: (...args: any[]) => void,
) {
  throttleFunctionData[name] = initialData;
  const getData = () => throttleFunctionData[name];
  const throttleFunction = throttle(
    () => {
      const data = getData();
      functionToCall(data);
      setData(null);
    },
    throttleDelayInMS,
    throttleOptions,
  );
  const call = () => {
    throttleFunction();
  };
  const cancel = () => {
    throttleFunction.cancel();
    throttleFunctionData[name] = null;
  };
  const setData = (newData: any) => {
    const data = getData();
    throttleFunctionData[name] = isObject(newData) && newData ? { ...data, ...newData } : newData;
  };

  call();

  return {
    call,
    cancel,
    setData,
    getData,
  };
}
